import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=865218f4&scoped=true&"
import script from "./js/header.js?vue&type=script&lang=js&"
export * from "./js/header.js?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=865218f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865218f4",
  null
  
)

export default component.exports